export default "__VITE_ASSET__2$7BqJD___"